import { Injectable } from '@angular/core';
import {ResourcePlanerService} from "./resource-planer.service";
import {BehaviorSubject, map, tap} from "rxjs";
import {ICreateSchedulerItemRequest, IEvent, IEventRequest, ISchedulerEvent, ISchedulerItem, ISearchSchedulerItemRequest, IUpdateSchedulerItemRequest} from "../models/scheduler";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ResourcePlanerStoreService {

  constructor(
    private http: HttpClient,
    private schedulerService: ResourcePlanerService) { }

  private _events$ = new BehaviorSubject<ISchedulerItem[]>([]);
  public events$ = this._events$.asObservable();

  listSchedulerItemsRequest : ISearchSchedulerItemRequest = {
    pageNumber : 0,
    pageSize: 999999,
    start: new Date(new Date().setUTCHours(0,0,0,0)),
    end: new Date(new Date().setUTCHours(23,59,59,999))
  }

  listSchedulerItems(){
    this.schedulerService.listEvents(this.listSchedulerItemsRequest)
      .subscribe(response => {
        this._events$.next(response.data);
      })
  }

  addEvent(event : ICreateSchedulerItemRequest){
    console.log(event, "payload in store service before api call");
    this.schedulerService.addEvent(event)
      .subscribe(response => {
        if (response){
          this.listSchedulerItems();
        }
      })
  }

  updateEvent(event : IUpdateSchedulerItemRequest){
    this.schedulerService.updateEvent(event)
      .subscribe(response => {
        if (response){
          this.listSchedulerItems();
        }
      })
  }

  deleteEvent(id : string){
    this.schedulerService.deleteEvent(id)
      .subscribe(response => {
        this.listSchedulerItems();
      })
  }

}
